function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import useIntlMemo from '@/hooks/useIntlMemo';
import { TimeoutReasons } from '@/types/server';
import { Badge } from '@mantine/core';
import React from 'react';
var _obj;
var TimeoutReasonColorMap = (_obj = {}, _define_property(_obj, TimeoutReasons.BLACKLIST, 'red'), _define_property(_obj, TimeoutReasons.CAPS, 'orange'), _define_property(_obj, TimeoutReasons.SPAM, 'yellow'), _define_property(_obj, TimeoutReasons.EMOTES, 'green'), _define_property(_obj, TimeoutReasons.LINKS, 'blue'), _define_property(_obj, TimeoutReasons.SYMBOLS, 'purple'), _obj);
function TimeoutReasonTag(_param) {
    var reason = _param.reason, props = _object_without_properties(_param, [
        "reason"
    ]);
    var TimeoutReasonMap = useIntlMemo(function(intl) {
        var _obj;
        return _obj = {}, _define_property(_obj, TimeoutReasons.BLACKLIST, intl.formatMessage({
            id: "IhLMxa",
            defaultMessage: [
                {
                    type: 0,
                    value: "Banned Phrase"
                }
            ]
        })), _define_property(_obj, TimeoutReasons.CAPS, intl.formatMessage({
            id: "Fp0WEb",
            defaultMessage: [
                {
                    type: 0,
                    value: "Excessive Caps"
                }
            ]
        })), _define_property(_obj, TimeoutReasons.SPAM, intl.formatMessage({
            id: "igpX9R",
            defaultMessage: [
                {
                    type: 0,
                    value: "Command Spam"
                }
            ]
        })), _define_property(_obj, TimeoutReasons.EMOTES, intl.formatMessage({
            id: "rtJ/Ut",
            defaultMessage: [
                {
                    type: 0,
                    value: "Emote Spam"
                }
            ]
        })), _define_property(_obj, TimeoutReasons.LINKS, intl.formatMessage({
            id: "dyMGFi",
            defaultMessage: [
                {
                    type: 0,
                    value: "Link Spam"
                }
            ]
        })), _define_property(_obj, TimeoutReasons.SYMBOLS, intl.formatMessage({
            id: "5+/gBF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Symbol Spam"
                }
            ]
        })), _obj;
    });
    return /*#__PURE__*/ _jsx(Badge, _object_spread_props(_object_spread({
        radius: "sm",
        variant: "light",
        color: TimeoutReasonColorMap[reason]
    }, props), {
        children: TimeoutReasonMap[reason]
    }));
}
export default TimeoutReasonTag;
